import { MouseEvent } from "react";

interface ThirdPartyConsentModalProps {
  open: boolean;
  onClose: () => void;
}

const ThirdPartyConsentModal = ({
  open,
  onClose,
}: ThirdPartyConsentModalProps) => {
  if (!open) {
    return null;
  }

  const handleRootClick = () => {
    onClose();
  };

  const stopPropagation = (event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
  };

  return (
    <div className="modal_backdrop" onClick={handleRootClick}>
      <div className="modal_container privacy_policy_modal" onClick={stopPropagation}>
        <div className="modal_header privacy">
          <div className="modal_title">개인정보 제3자 제공 동의</div>
          <button type="button" className="modal_close_button" onClick={onClose} aria-label="닫기">
            &times;
          </button>
        </div>
        <div className="privacy_modal_body">
          <p>
            본 기관은 「개인정보 보호법」 제17조 및 제18조에 따라 다음과 같이 개인정보를 제3자에게 제공하는 것에 동의를 얻고자 합니다.
          </p>

          <section className="privacy_modal_section">
            <ul>
              <li><strong>개인정보를 제공받는 자:</strong> 코어데브</li>
              <li><strong>개인정보 이용 목적:</strong> 운세서비스 제공 및 이메일, 카톡 발송</li>
              <li><strong>제공하는 개인정보 항목:</strong> 이름, 연락처, 생년월일, 시간, 이메일</li>
              <li><strong>개인정보 보유 및 이용 기간:</strong> 제공 동의 철회 시까지</li>
              <li>
                <strong>동의를 거부할 권리가 있다는 사실 및 동의 거부에 따른 불이익 내용:</strong>{" "}
                동의하지 않을 경우 해당 서비스(예: 사주 분석, 이벤트 참여) 이용이 제한될 수 있습니다.
              </li>
            </ul>
          </section>

          <button type="button" className="privacy_modal_cta_button" onClick={onClose}>
            확인
          </button>
        </div>
      </div>
    </div>
  );
};

export default ThirdPartyConsentModal;